import * as actions from './actionTypes';

/**
 * Agent Scanner Redux Reducer
 * Following the same pattern as clientApplications/reducer.js
 *
 * Currently only handles list state.
 * Additional state (create, update, delete, etc.) can be added as needed.
 */

const initialState = {
  // List state
  scanners: [],
  isFetchingScanners: false,
  scannersError: null,
  // Pagination state
  currentPage: 0,
  pageSize: 10,
  totalElements: 0,
  totalPages: 0,
  hasMorePages: false,
  // Scanner runs (history) state
  scannerRuns: [],
  isFetchingScannerRuns: false,
  isFetchingStagingAgents: false,
  scannerRunsError: null,
  scannerRunsScannerId: null,
  scannerRunsCurrentPage: 0,
  scannerRunsTotalPages: 0,
  scannerRunsTotalElements: 0,
  // Agent capacity (used / total); null when API unavailable
  agentCapacity: null,
  isFetchingCapacity: false,
  capacityError: null,
  capacityBannerDismissed: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // List operations
    case actions.FETCH_AGENT_SCANNER_LIST_REQUEST:
      return {
        ...state,
        isFetchingScanners: true,
        scannersError: null
      };

    case actions.FETCH_AGENT_SCANNER_LIST_SUCCESS:
      return {
        ...state,
        isFetchingScanners: false,
        scanners: action.pageData.content, // Extract content from Page object
        scannersError: null,
        // Update pagination metadata
        currentPage: action.pageData.pageable?.pageNumber || 0,
        pageSize: action.pageData.pageable?.pageSize || 10,
        totalElements: action.pageData.totalElements || 0,
        totalPages: action.pageData.totalPages || 0,
        hasMorePages: !action.pageData.last
      };

    case actions.FETCH_AGENT_SCANNER_LIST_FAILURE:
      return {
        ...state,
        isFetchingScanners: false,
        scannersError: action.error
      };

    // Create operations
    case actions.CREATE_AGENT_SCANNER_SUCCESS:
      return {
        ...state,
        scanners: [action.scanner, ...state.scanners], // Add new scanner to the beginning
        totalElements: state.totalElements + 1
      };

    // Update operations
    case actions.UPDATE_AGENT_SCANNER_SUCCESS:
      return {
        ...state,
        scanners: state.scanners.map((scanner) =>
          scanner.id === action.scanner.id ? action.scanner : scanner
        )
      };

    // Scanner runs operations
    case actions.FETCH_SCANNER_RUNS_REQUEST:
      return {
        ...state,
        isFetchingScannerRuns: true,
        scannerRunsError: null,
        scannerRunsScannerId: action.scannerId
      };

    case actions.FETCH_SCANNER_RUNS_SUCCESS:
      return {
        ...state,
        isFetchingScannerRuns: false,
        scannerRuns: action.pageData.content,
        scannerRunsError: null,
        scannerRunsScannerId: action.scannerId,
        scannerRunsCurrentPage: action.pageData.pageable?.pageNumber || 0,
        scannerRunsTotalPages: action.pageData.totalPages || 0,
        scannerRunsTotalElements: action.pageData.totalElements || 0
      };

    case actions.FETCH_SCANNER_RUNS_FAILURE:
      return {
        ...state,
        isFetchingScannerRuns: false,
        scannerRunsError: action.error
      };

    case actions.CLEAR_SCANNER_RUNS:
      return {
        ...state,
        scannerRuns: [],
        isFetchingScannerRuns: false,
        scannerRunsError: null,
        scannerRunsScannerId: null,
        scannerRunsCurrentPage: 0,
        scannerRunsTotalPages: 0,
        scannerRunsTotalElements: 0
      };

    // Staging Agents operations
    case actions.FETCH_STAGIN_AGENTS_REQUEST:
      return {
        ...state,
        isFetchingStagingAgents: true,
        stagingAgentsError: null,
        stagingAgentsScanRunId: action.scanRunId
      };

    case actions.FETCH_STAGIN_AGENTS_SUCCESS:
      return {
        ...state,
        isFetchingStagingAgents: false,
        stagingAgents: action.pageData.content,
        stagingAgentsError: null,
        stagingAgentsScanRunId: action.scanRunId
      };

    case actions.FETCH_STAGIN_AGENTS_FAILURE:
      return {
        ...state,
        isFetchingStagingAgents: false,
        stagingAgentsError: action.error
      };

    // Agent capacity
    case actions.FETCH_AGENT_CAPACITY_REQUEST:
      return {
        ...state,
        isFetchingCapacity: true,
        capacityError: null
      };

    case actions.FETCH_AGENT_CAPACITY_SUCCESS:
      return {
        ...state,
        isFetchingCapacity: false,
        agentCapacity: action.capacity,
        capacityError: null
      };

    case actions.FETCH_AGENT_CAPACITY_FAILURE:
      return {
        ...state,
        isFetchingCapacity: false,
        agentCapacity: null,
        capacityError: action.error
      };

    case actions.DISMISS_CAPACITY_BANNER:
      return {
        ...state,
        capacityBannerDismissed: true
      };

    default:
      return state;
  }
}
